import { Component } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';

export interface ITagDialogProcessUntagData {
    step1: {
        message: string;
        buttonText: string;
    };
    step2: {
        message: string;
        buttonText: string;
        confirmTextToInput2: string;
    };
}

@Component({
    selector: 'fi-tag-dialog-process-untag',
    templateUrl: './tag-dialog-process-untag.component.html',
    styleUrls: ['./tag-dialog-process-untag.component.scss'],
    standalone: false,
})
export class TagDialogProcessUntagComponent extends FiDialogsContentBase<ITagDialogProcessUntagData, boolean> {
    step: number = 1;
    confirmText2: string = '';

    ngOnInit() {}

    onYesButtonClick($event) {
        if (this.step === 1) {
            $event.preventDefault();
            this.step = 2;
        }
    }

    getYesButtonText() {
        return this.step === 1 ? this.data.step1.buttonText.toUpperCase() : this.data.step2.buttonText.toUpperCase();
    }

    isYesButtonDisabled() {
        return this.step === 2 && this.confirmText2 !== this.data.step2.confirmTextToInput2;
    }
}
